// Prototype booking data — MOCK availability. This entire file is replaced
// by the real Jotform booking engine in production.

export const styleSizes = ["Small", "Medium", "Large", "Jumbo"];

export const styleLengths = ["Shoulder", "Mid-back", "Waist", "Extra Long"];

export const hairColors = ["1", "1B", "2", "4", "27", "30", "613", "Custom / Mixed"];

export const timeSlots = ["9:00 AM", "12:30 PM", "4:00 PM"];

export const hairTypes = [
  "Natural",
  "Relaxed",
  "Previously braided",
  "Locs",
  "Other",
];

export const hairLengths = [
  "Very short",
  "Above shoulder",
  "Shoulder",
  "Below shoulder",
];

export const DEPOSIT = 25;

// Deterministic mock availability for the next 14 days (closed Sundays).
export const buildAvailability = () => {
  const days = [];
  const today = new Date();
  for (let i = 1; i <= 14; i++) {
    const d = new Date(today);
    d.setDate(today.getDate() + i);
    if (d.getDay() === 0) continue;
    const slots = timeSlots.map((t, idx) => ({
      time: t,
      booked: (d.getDate() + idx) % 3 === 0,
    }));
    days.push({
      iso: d.toISOString().slice(0, 10),
      label: d.toLocaleDateString("en-US", { weekday: "short" }),
      day: d.getDate(),
      month: d.toLocaleDateString("en-US", { month: "short" }),
      slots,
    });
  }
  return days;
};

export const prettyDate = (iso) => {
  if (!iso) return "";
  const d = new Date(`${iso}T12:00:00`);
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });
};

